<template>
  <div class="layout-error flex flex-col">
    <TheHeader variant="logo-only" />
    <main
      class="content-wrap flex flex-1 flex-col items-center mt-300 px-200 gap-300"
    >
      <div class="text-center">
        <h1 class="headline-h4-headline mb-200">
          {{ $t(`error.page.${errorType}.title`) }}
        </h1>
        <p>
          {{ $t(`error.page.${errorType}.text`) }}
        </p>
      </div>

      <Illustration :name="`error-${errorType}`" />

      <HyperLink
        v-if="isNotFound"
        class="text-center block text-link"
        :to="$localePath('/service?chat=true')"
      >
        {{
          $t('error.page.notfound.prompt', {
            contactSupport: $t('common.sentences.contactsupport'),
          })
        }}
      </HyperLink>

      <LcButton v-else @click="handleError">
        {{ $t('error.page.general.button.reload') }}
      </LcButton>
    </main>

    <TheBottomNavigation />
  </div>
</template>

<script lang="ts" setup>
import type { NuxtError } from 'nuxt/app'

import { LcButton } from '@lottocom/frontend-components'

type ErrorProps = {
  error: NuxtError
}

const { error } = defineProps<ErrorProps>()

const { t } = useI18n()

const { log } = useDatadog()

const handleError = () => {
  clearError({ redirect: '/' })
}

onMounted(() => {
  try {
    log('error', {
      component: 'error-page',
      error: error,
      message: error.message,
      messageContext: {
        url: window.location.href,
      },
    })
  } catch {
    // Do nothing
  }
})

const errorType = computed(() =>
  error.statusCode === 404 ? 'notfound' : 'general',
)
const isNotFound = computed(() => errorType.value === 'notfound')

useHead({
  title: t(`error.page.${errorType.value}.title`),
})
</script>

<style lang="scss" scoped>
.layout-error {
  min-height: 100dvh;
  padding-bottom: $main-bottom-navigation-height;
}
</style>
